import { render, staticRenderFns } from "./ManageBrokerMail.vue?vue&type=template&id=5e04da44"
import script from "./ManageBrokerMail.vue?vue&type=script&lang=js"
export * from "./ManageBrokerMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports